export default {
    Metadata: {
        Name: "Reverse",
        Description: "Returns the given string in reverse order.",
        Syntax: "Reverse(string)",
        Keywords: ['String', 'Text'],
        Author: "DataVoke, Inc.",
    },
    execute(inputString) {
        if (inputString == null) {
            return null;
        }

        if (typeof inputString != 'string')
            inputString = inputString.toString();

        return inputString.split("").reverse().join("");
    },
};

